export default __webpack_public_path__ + "static/media/analytics.384c939c.svg";